'use client'

import { type FC, Fragment } from 'react'
import { useHits } from 'react-instantsearch'

import { type AlgoliaProxyRecord } from '../../../algolia'
import { ProductVolumePricingContextProvider } from '../../../product'
import {
  mapAlgoliaVolumeBasedPrices,
  ProductSearchResultItem,
  ProductSearchResultItemContextProvider,
  useProductSearchResultsGtmTracker,
} from '../../../product-search'
import { SearchPageAdBannerBottom } from '../../ad-banner/SearchPageAdBannerBottom'
import {
  SEARCH_PAGE_AD_BANNER_SEARCH_BOTTOM_POSITION,
  SEARCH_PAGE_AD_BANNER_SEARCH_MIDDLE_POSITION,
} from '../../ad-banner/SearchPageAdBannerConfig'
import { SearchPageAdBannerMiddle } from '../../ad-banner/SearchPageAdBannerMiddle'

export const SearchPageResultList: FC = () => {
  const { items: algoliaHits, results } = useHits<AlgoliaProxyRecord>()
  useProductSearchResultsGtmTracker(results)
  // Ensure only valid products are rendered
  const items = algoliaHits.filter((item) => Boolean(item.productName))

  return (
    <ul className="grid gap-9">
      {items.map((item, index) => (
        <Fragment key={item.id}>
          <li data-qa-id="result-list-entry">
            <ProductSearchResultItemContextProvider
              algoliaRecord={item}
              query={results?.query}
            >
              <ProductVolumePricingContextProvider
                currentVariant={item}
                volumeBasedPrices={mapAlgoliaVolumeBasedPrices(
                  item.best_offer?.volume_based_prices ?? [],
                )}
              >
                <ProductSearchResultItem />
              </ProductVolumePricingContextProvider>
            </ProductSearchResultItemContextProvider>
          </li>

          {index + 1 === SEARCH_PAGE_AD_BANNER_SEARCH_MIDDLE_POSITION ? (
            <SearchPageAdBannerMiddle wrapperComponent="li" />
          ) : null}

          {index + 1 === SEARCH_PAGE_AD_BANNER_SEARCH_BOTTOM_POSITION ? (
            <SearchPageAdBannerBottom wrapperComponent="li" />
          ) : null}
        </Fragment>
      ))}
    </ul>
  )
}
